export default "__VITE_ASSET__Bob58bGI__"